import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label,
} from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../UserInfo";
import { LoadIndicator } from "devextreme-react/load-indicator";
import api from "../api-axios";


const template = {
    _uiCarregando: false,
    algoritmo: "CONTRIBUINTE_MANUAL",
    codigosOrigem: "",
    codigoDestino: "",
};

export default class UnificarCadastrosForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = { ...template };

        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);

        this.algoritmoOptions = {
            editorType: "dxSelectBox",
            dataSource: [
                { id: "CONTRIBUINTE_MANUAL", descricao: "CONTRIBUINTE" },
            ],
            valueExpr: "id",
            displayExpr: "descricao",
            placeholder: " "
        };

    }


    render() {

        if (this.state._uiCarregando) {
            return (
                <div className={"content-block dx-card responsive-paddings"}>
                    <div
                        style={{
                            display: "block",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <LoadIndicator width={60} height={60} />
                        <div>Processando...</div>
                    </div>
                </div>
            );
        }


        return (
            <React.Fragment>
                <div className={"content-block dx-card responsive-paddings"}>
                    <Form formData={this.state} colCount={1}>
                        <GroupItem caption="UNIFICAÇÃO DE CADASTROS - PROCESSO IRREVERSÍVEL!">
                            <SimpleItem
                                dataField={"algoritmo"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.algoritmoOptions}
                                colSpan={4}
                            >
                                <Label text="Tipo Unificação" />
                            </SimpleItem>

                            <SimpleItem dataField={"codigosOrigem"}>
                                <Label text="Códigos de Origem" />
                            </SimpleItem>
                            <SimpleItem dataField={"codigoDestino"}>
                                <Label text="Código Destino" />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <div
                        style={{
                            display: "flex",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={120}
                                text="Salvar"
                                type="success"
                                onClick={this.ok}
                            />
                        </div>
                        <div style={{ marginLeft: "10px" }}>
                            <Button
                                width={120}
                                text="Cancelar"
                                type="danger"
                                onClick={this.cancel}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    async ok() {
        const request = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };

        this.setState({ _uiCarregando: true });

        let newState = this.state;

        try {
            await api.post("unificarcadastros/unificar", request);
            notify("Unificação realizada com sucesso", "success");
            newState = template;
        }
        catch (err) {
            console.log(err.response);
            notify(err.response.data, "error");
        }
        finally {
            this.setState({ ...newState, _uiCarregando: false });
        }
    }

    cancel() {
        notify("Operação cancelada", "warning");
        this.props.history.goBack();
    }
}
